import { Message } from 'semantic-ui-react';

function NotFound() {
    return (
        <Message warning>
            <Message.Header>Invalid Verification Type</Message.Header>
            <p>Please check the URL or contact the system administrator.</p>
        </Message>
    );
}

export default NotFound;
